class ProductTabs extends HTMLElement {
  constructor() {
    super();
    this.tabTitles = [];
    this.tabContents = [];
  }

  connectedCallback() {
    // Select all tab titles and contents within this component
    this.tabTitles = this.querySelectorAll(".product__tab-title");
    this.tabContents = this.querySelectorAll(".product__tab-text");
    this.toggleButtons = this.querySelectorAll(".toggleDescription");

    // Initialize the tabs by setting up event listeners only
    this.initTabs();

    // Set up event listeners for each toggleDescription button and check content height
    this.toggleButtons.forEach((toggleButton) => {
      const description = toggleButton.previousElementSibling; // Target the content above the toggle button

      // Check if the content height exceeds 7.5em
      if (this.isContentOverflowing(description, 7.5)) {
        toggleButton.classList.add("show-toggle"); // Add a class to show the toggle button
        toggleButton.addEventListener("click", (event) => this.toggleDescription(event));
      } else {
        toggleButton.style.display = "none"; // Hide the button if content doesn't overflow
      }
    });
  }

  initTabs() {
    // Add click event listeners to each tab title
    this.tabTitles.forEach((tabTitle) =>
      tabTitle.addEventListener("click", (event) => this.onTabClick(event))
    );
  }

  isContentOverflowing(element, maxEm) {
    const maxHeight = maxEm * parseFloat(getComputedStyle(document.documentElement).fontSize);
    return element.scrollHeight > maxHeight;
  }

  onTabClick(event) {
    // Retrieve the data-index attribute of the clicked tab
    const selectedTab = event.currentTarget;
    const selectedIndex = selectedTab.getAttribute("data-index");

    // Activate the selected tab and the corresponding content
    this.activateTab(selectedIndex);
  }

  activateTab(index) {
    // Remove the active class from all tab titles and contents
    this.tabTitles.forEach((tabTitle) => tabTitle.classList.remove("active"));
    this.tabContents.forEach((tabContent) => tabContent.classList.remove("active"));

    // Add the active class to the selected tab title and corresponding content
    const activeTitle = this.querySelector(`.product__tab-title[data-index="${index}"]`);
    const activeContent = this.querySelector(`.product__tab-text[data-index="${index}"]`);

    if (activeTitle && activeContent) {
      activeTitle.classList.add("active");
      activeContent.classList.add("active");
    }
  }

  toggleDescription(event) {
    const toggleButton = event.currentTarget;
    const description = toggleButton.previousElementSibling; // Target the content above the toggle button

    // Toggle expanded state
    if (description.classList.contains("expanded")) {
      description.classList.remove("expanded");
      toggleButton.textContent = "Read more...";
    } else {
      description.classList.add("expanded");
      toggleButton.textContent = "Read less...";
    }
  }
}

// Define the custom element
customElements.define('product-tabs', ProductTabs);

class ProductAccordions extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Select all accordion buttons within this component
    this.accordionButtons = this.querySelectorAll(".accordion__label");
    this.toggleButtons = this.querySelectorAll(".toggleDescription");

    // Set up event listeners for accordion buttons
    this.accordionButtons.forEach((button) => {
      button.addEventListener("click", (event) => this.toggleAccordion(event));
    });

    // Set up event listeners for each toggleDescription button
    this.toggleButtons.forEach((toggleButton) => {
      toggleButton.addEventListener("click", (event) => this.toggleDescription(event));
    });
  }

  toggleAccordion(event) {
    const button = event.currentTarget;
    const accordion = button.closest(".accordion");
    const content = accordion.querySelector(".accordion__content");
    const isOpen = button.getAttribute("aria-expanded") === "true";

    // Close all other accordions
    this.closeAllAccordions();

    if (!isOpen) {
      // Open the clicked accordion with animation
      button.setAttribute("aria-expanded", "true");
      content.setAttribute("aria-hidden", "false");
      this.animateOpen(content);
    }
  }

  closeAllAccordions() {
    this.accordionButtons.forEach((btn) => {
      const accordion = btn.closest(".accordion");
      const content = accordion.querySelector(".accordion__content");

      // Set all other accordions to closed state with animation
      btn.setAttribute("aria-expanded", "false");
      content.setAttribute("aria-hidden", "true");
      this.animateClose(content);
    });
  }

  animateOpen(element) {
    element.style.display = 'block'; // Ensure it's visible
    element.style.height = '0px';
    element.style.overflow = 'hidden';
    element.style.transition = 'height 0.3s ease';

    // Use scrollHeight to animate to full height
    requestAnimationFrame(() => {
      element.style.height = `${element.scrollHeight}px`;
    });

    element.addEventListener('transitionend', function handleTransitionEnd() {
      element.style.height = 'auto'; // Set to auto after animation ends for flexible content
      element.removeEventListener('transitionend', handleTransitionEnd);
    });
  }

  animateClose(element) {
    element.style.height = `${element.scrollHeight}px`; // Set current height before collapsing
    element.style.overflow = 'hidden';
    element.style.transition = 'height 0.3s ease';

    requestAnimationFrame(() => {
      element.style.height = '0px'; // Collapse height
    });
  }

  toggleDescription(event) {
    const toggleButton = event.currentTarget;
    const description = toggleButton.previousElementSibling; // Target the content above the toggle button

    // Toggle expanded state
    if (description.classList.contains("expanded")) {
      description.classList.remove("expanded");
      toggleButton.textContent = "Read more...";
    } else {
      description.classList.add("expanded");
      toggleButton.textContent = "Read less...";
    }
  }
}

// Define the custom element
customElements.define('product-accordions', ProductAccordions);